import style from './styles/HeaderArea.scss';
import MutationService from '../../../services/MutationService';
import CurrencyService from '../../../services/CurrencyService';
import IntroductionArea from './IntroductionArea';
import { Desktop } from '../../../helpers/MediaQueries';
import RouteHelper from '../../../helpers/RouteHelper';
import { Link } from 'react-router-dom';

const HeaderArea = ({ className, raffle }) => {
	const mutationCode = MutationService.getMutationCode();
	const currency = CurrencyService.getCurrency();
	const shipping = <span className={style.shipping}><span> + </span><Link to={RouteHelper.getUrl('/shipping')}>Shipping</Link></span>;
	return (
		<div className={className}>
			<h1 className={style.name}>{raffle.getTitle(mutationCode)}</h1>
			<div className={style.variant}>{raffle.getSubtitle(mutationCode)}</div>
			<div className={style.divider} />
			<div>
				<span className={style.symbol}>{currency.symbolBefore}</span>
				<span className={style.price}>{CurrencyService.round(raffle.getPrice(currency.code))}</span>
				<span className={style.symbol}>{currency.symbolAfter}</span>
				{shipping}
			</div>
			<Desktop>
				<IntroductionArea raffle={raffle} />
			</Desktop>
		</div>
	);
};

export default HeaderArea;


// WEBPACK FOOTER //
// ./components/blocks/raffleDetail/HeaderArea.js